import React, { useState } from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Playwrightpages.module.css";

const PwActions = () => {
  const [message, setMessage] = useState("");            // for click tests
  const [text, setText] = useState("bspark");              // input default
  const [inputDisabled, setInputDisabled] = useState(false);
  const [submitMsg, setSubmitMsg] = useState("");          // submit result

  const sections = [
    {
      heading: "Click & Double Click",
      ui: (
        <div className={styles.actionGroup}>
          <button onClick={() => setMessage("Button Clicked!")}>Click Me</button>

          <button onDoubleClick={() => setMessage("Double Clicked!")}>Double Click Me</button>

          <p>{message}</p>
        </div>
      ),
      code: `// Single Click
await page.click('text=Click Me');

// Double Click
await page.dblclick('text=Double Click Me');`
    },
    {
      heading: "Clear Input & Disable / Enable",
      ui: (
        <div className={styles.actionGroup}>
          <input
            value={text}
            onChange={(e) => setText(e.target.value)}
            disabled={inputDisabled}
          />

          <button onClick={() => setSubmitMsg(`Welcome ${text}`)}>Submit</button>
          {submitMsg && <p style={{ color: 'green' }}>{submitMsg}</p>}

          <button onClick={() => setInputDisabled(!inputDisabled)}>
            {inputDisabled ? "Enable Input" : "Disable Input"}
          </button>
        </div>
      ),
      code: 
`// example assertions
await page.fill('input', 'bspark');
await page.click('text=Submit');`
    }
  ];

  return (
    <PlaywrightTemplate
      title="PLAYWRIGHT ACTIONS"
      sections={sections}
    />
  );
};

export default PwActions;